var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
var ContextualHelpContainer = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var font = _a.theme.font;
    return "\n    font-size: ".concat(font.body.xs.size, ";\n    line-height: ").concat(font.body.xs.lineHeight, ";\n    width: 100%;\n  ");
});
var ContextualHelpNotification = function (_a) {
    var id = _a.id, className = _a.className, content = _a.content;
    if (!content) {
        return null;
    }
    return (React.createElement(ContextualHelpContainer, __assign({}, (id && { id: id }), { className: className }), content));
};
export { ContextualHelpNotification };
var templateObject_1;
//# sourceMappingURL=ContextualHelpNotification.js.map